export enum ViewLayoutType {
  list = 'list',
  grid = 'grid',
}

export enum MeasureType {
  in = 'in',
  mm = 'mm',
}

export type CategoryQueryFilter = {
  categoryFilter: string
}

export type ShapeQueryFilter = {
  shapesFilter: string[]
}

export type VerticalQueryFilter = {
  verticalMaxFilter: number
  verticalMinFilter: number
  verticalMidFilter: number
  verticalMeasureType: MeasureType | null
}

export type HorizontalQueryFilter = {
  horizontalMaxFilter: number
  horizontalMinFilter: number
  horizontalMidFilter: number
  horizontalMeasureType: MeasureType | null
}

export type PriceQueryFilter = {
  priceFilter: number
}

export type QueryFilter = CategoryQueryFilter &
  ShapeQueryFilter &
  VerticalQueryFilter &
  HorizontalQueryFilter &
  PriceQueryFilter

export type OnChangeFilter = (changedValue: Partial<QueryFilter>) => void
